const uPass = function () {
    const KEY_UPASS_BANNER_HIDDEN = 'uPassBannerHidden';
    const KEY_UPASS_BANNER_NB_PAGE_VISITED = 'uPassBannerNbPageVisited';

    const _setBanner = function () {
        let $banner = $('.upass-banner');
        if ($banner.length) {
            let isClosedByUser = TINK.getLocalStorageWithExpiry(KEY_UPASS_BANNER_HIDDEN);
            let isClosedForSession = sessionStorage.getItem(KEY_UPASS_BANNER_HIDDEN);
            if (isClosedByUser === null && isClosedForSession === null) {
                let uPassBannerNbPageVisited = parseInt(sessionStorage.getItem(KEY_UPASS_BANNER_NB_PAGE_VISITED)) || 0;
                let maxPageVisited = parseInt($banner.attr('data-upass-banner-max-page-visited'));
                if (sessionStorage.getItem(KEY_UPASS_BANNER_NB_PAGE_VISITED) < maxPageVisited) {
                    uPassBannerNbPageVisited++;

                    // Display banner
                    $banner.removeClass('hide');
                    $banner.addClass('show');

                    // If cookie consent is displayed, apply offset
                    let $cookieConsent = $('.cookie-consent');
                    if ($cookieConsent.length && $cookieConsent.is(':visible')) {
                        $banner.addClass('cookie-consent-offset');
                    }

                    // Setup banner closure
                    if (uPassBannerNbPageVisited === maxPageVisited) {
                        sessionStorage.setItem(KEY_UPASS_BANNER_HIDDEN, 'true');
                        sessionStorage.removeItem(KEY_UPASS_BANNER_NB_PAGE_VISITED);
                    } else {
                        sessionStorage.setItem(KEY_UPASS_BANNER_NB_PAGE_VISITED, uPassBannerNbPageVisited.toString());
                    }
                    let timeBeforeClosing = parseInt($banner.attr('data-upass-banner-closing-timeout'));
                    setTimeout(() => {
                        $banner.removeClass('show');
                    }, timeBeforeClosing);
                } else {
                    _closeBannerForSession($banner);
                }
            }

            $('#closeUPassBannerBtn').click(function () {
                _closeBannerWithExpiry($banner);
            });
        }
    }

    const _closeBannerWithExpiry = function ($banner) {
        if ($banner.length) {
            _setExpiry($banner);
            $banner.hide();
        }
    }

    const _closeBannerForSession = function ($banner) {
        if ($banner.length) {
            sessionStorage.setItem(KEY_UPASS_BANNER_HIDDEN, 'true');
            sessionStorage.removeItem(KEY_UPASS_BANNER_NB_PAGE_VISITED);
            $banner.hide();
        }
    }

    const _setExpiry = function ($banner) {
        let expiration = parseInt($banner.attr('data-upass-banner-closing-duration'));
        TINK.setLocalStorageWithExpiry(KEY_UPASS_BANNER_HIDDEN, true, expiration);
        sessionStorage.removeItem(KEY_UPASS_BANNER_NB_PAGE_VISITED);
    }

    const _setBannerOffset = function (state) {
        let $banner = $('.upass-banner');
        if ($banner.length) {
            if (state) {
                $banner.addClass('cookie-consent-offset');
            } else {
                $banner.removeClass('cookie-consent-offset');
            }
        }
    }

    const _getCartUPassAisleSubTotal = function (uPassAisleId) {
        let uPassAisleSubTotal = 0;
        if (typeof uPassAisleId !== 'undefined' && uPassAisleId !== null) {
            let $uPassAisle = $('[data-aisle="' + uPassAisleId + '"]');
            if ($uPassAisle.length) {
                uPassAisleSubTotal = $uPassAisle.find('[data-subtotal-price]').attr('data-subtotal-price');
            }
        }
        return uPassAisleSubTotal;
    }

    return {
        setBanner: _setBanner,
        setBannerOffset: _setBannerOffset,
        getCartUPassAisleSubTotal: _getCartUPassAisleSubTotal
    }
}();
